import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormStateService } from '../form-state.service';
import { BusinessDetailsNewComponent } from '../business-details-new/business-details-new.component';
import { InchargeOwnerDetailsComponent } from '../incharge-owner-details/incharge-owner-details.component';
import { ServiceOfferedNewComponent } from '../service-offered/service-offered.component';
import { TechnicianInfoComponent } from '../technician-info/technician-info.component';
import { SubscriptionPlanComponent } from '../subscription-plan/subscription-plan.component';
import { PaymentComponent } from '../payment/payment.component';
import { ServiceProviderComponent } from '../../service-provider.component';
import { ServiceProviderService } from '../../../../Service/Service-providers/service-provider.service';
import { MapLocationComponent } from '../../../../location/map-location/map-location.component';
import { AddressproofComponent } from '../../../../location/addressproof/addressproof.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { BrandDetailsComponent } from '../brand-details/brand-details.component';

@Component({
  selector: 'app-add-sp',
  templateUrl: './add-sp.component.html',
  styleUrls: ['./add-sp.component.scss'],
})
export class AddSpComponent implements OnInit, AfterViewChecked {
  technicianInfo: any;
  editMode: any;
  @Input() id?: any;
  selectedBusinessType: any;
  selectedServices!: any[];
  prevSection: string = '';
  @Output() updateProviderList = new EventEmitter<void>();
  constructor(
    private cdr: ChangeDetectorRef,
    public spFormstate: FormStateService,
    private api: ServiceProviderService,
    private route: ActivatedRoute,
    private location: Location,
    private router: Router,
  ) { }

  ngOnInit(): void {
    const routeId = this.route.snapshot.paramMap.get('serviceProviderId');
    this.id = this.id || (routeId ? +routeId : null);

    console.log('Received ID from route:', this.id);

    this.editMode = !!this.id;

    if (this.editMode) {
      this.serviceProviderById(this.id!); // fetch and patch data in edit mode
    }
    this.setActiveSection(this.activeSection)

    this.cdr.detectChanges();
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes['id'] && changes['id'].currentValue) {
  //     console.log('ID in ngOnChanges:', changes['id'].currentValue);
  //     this.editMode = false;
  //     this.serviceProviderById(changes['id'].currentValue);
  //   }
  // }
  ngAfterViewChecked(): void {
    if (
      this.activeSection === 'address-proof' &&
      this.activeSection !== this.prevSection &&
      this.addressProof &&
      this.id
    ) {
      console.log('Calling addressProof.populateAddressProofFromResponse');
      this.api.getServiceproviderById(this.id).subscribe((res: any) => {
        this.addressProof.populateAddressProofFromResponse(res);
      });

      this.prevSection = this.activeSection;
    }
  }
  @ViewChild(ServiceProviderComponent)
  serviceProvider!: ServiceProviderComponent;

  @ViewChild(MapLocationComponent)
  mapLocation!: MapLocationComponent;

  @ViewChild(AddressproofComponent)
  addressProof!: AddressproofComponent;

  @ViewChild(BusinessDetailsNewComponent)
  businessDetailsFormComponent!: BusinessDetailsNewComponent;

  @ViewChild(InchargeOwnerDetailsComponent)
  ownerDetails!: InchargeOwnerDetailsComponent;

  @ViewChild(ServiceOfferedNewComponent)
  serviceOffered!: ServiceOfferedNewComponent;

  @ViewChild(TechnicianInfoComponent)
  technicianDetails!: TechnicianInfoComponent;

  @ViewChild(SubscriptionPlanComponent)
  subscriptionPlan!: SubscriptionPlanComponent;

  @ViewChild(BrandDetailsComponent)
  brandDetailComponent!: BrandDetailsComponent

  @ViewChild(PaymentComponent) payment!: PaymentComponent;

  @Output() updateServiceProviderList = new EventEmitter<void>();

  @Output() closeDialog = new EventEmitter<void>();

  activeSection: string = 'map-location';
  selectedPlan: any = null;
  countryId!: any;

  setActiveSection(section: string): void {
    this.activeSection = section;
    console.log(this.activeSection);

    if (this.editMode && this.id) {
      this.serviceProviderById(this.id)
    }
    if (section === 'map-location' && this.editMode && this.id) {
      console.log('Editmode when map-location is called:', this.editMode)
      this.serviceProviderById(this.id)
    }
    if (this.editMode && this.id) {
      if (section === 'business-details') {
        // Delay to ensure view is initialized
        console.log('edit mode')
        setTimeout(() => this.serviceProviderById(this.id!), 0);
      }
    }

  }

  onUpdateServiceProviderList(): void {
    this.updateServiceProviderList.emit();
  }

  onPlanSelected(plan: any): void {
    this.selectedPlan = plan;
  }

  close() {
    if (this.ownerDetails) {
      this.ownerDetails.resetForm();
    }
    if (this.serviceOffered) {
      this.serviceOffered.resetForm();
    }
    if (this.technicianDetails) {
      this.technicianDetails.resetForm();
    }
    if (this.mapLocation) {
      this.mapLocation.resetForm();
    }

    if (this.businessDetailsFormComponent) {
      this.businessDetailsFormComponent.resetForm();
    }
    this.spFormstate.clearFormData();
    this.closeDialog.emit();
    this.location.back()
  }

  setCountryId(countryId: string) {
    this.countryId = countryId;
  }
  serviceProviderById(id: number) {
    console.log('Service provider id is recieved in the method')

    this.api.getServiceproviderById(id).subscribe((res: any) => {
      if (this.mapLocation) {
        this.mapLocation.populateLocationFromBackend(res);
      }
      const existingOwnerDetailsData = this.spFormstate.getFormData('owner-details');

      if (this.addressProof) {
        this.addressProof.populateAddressProofFromResponse(res);
        console.log('Address proof is called')
      }

      if (this.businessDetailsFormComponent) {
        console.log('Edit business details is called')
        this.businessDetailsFormComponent.populateFormWithServiceProviderDetails(res);
      }

      if (this.ownerDetails) {
        this.ownerDetails.populateFormWithServiceProviderDetails(res)
      }

      if (this.serviceOffered) {
        console.log("Edit Service offered component");
        this.serviceOffered.populateFormWithServiceProviderDetails(res);
      }

      if (this.technicianDetails) {
        console.log("Edit technician details");
        this.technicianDetails.populateFormWithServiceProviderDetails(res);
      }
      if (this.brandDetailComponent) {
        console.log('Brand details component called');
        this.brandDetailComponent.populate(res)
      }
    });
  }
  onUpdateProviderList(): void {
    this.updateProviderList.emit();
  }
}
